import React, { useState, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import { toMoney, formatRut } from "src/utils/formatter";
import { documentsDic } from "src/utils/dataDictionary";
import { toExpandCollapse } from "src/utils/queryExpandCollaps";
import { useSelector } from "react-redux";

export default function ToNominaRow({
  element,
  addDocToNomina,
  addAllDocsToNomina,
  selectedDocsToNomina,
}) {
  const [collapse, setCollapse] = useState(true)

  useEffect(() => {
    toExpandCollapse({
      container: `nomina-container${element?.userId}`,
      expand: `nomina-row-to-show${element?.userId}`,
      containerHeight: 60,
      childrenHeight: element?.selected?.length * 33 + 10,
      collapse,
    });
  }, [collapse])

  return (
    <div
      className="custom-providers-table__selector mb-3"
      id={`nomina-container${element?.userId}`}
    >
      <div
        className="d-flex justify-content-between"
        onClick={() => {
          setCollapse(!collapse);
        }}
      >
        <div>
          <input
            type="checkbox"
            id={`${element?.userId}-select-all-dtes`}
            onClick={(e) =>
              addAllDocsToNomina(element?.selected, e.target.checked)
            }
            checked={element?.selected?.every((el) =>
              selectedDocsToNomina?.some(
                (item) => item?.selectionId === el?.selectionId
              )
            )}
          />
        </div>
        <div>
          <span>{element?.userEmail || 'Desconocido'}</span>
        </div>
        <div className="d-flex">
          <span className="mr-3">
            Seleccionados: {element?.selected.length}
          </span>
          <Icon
            className="cursor-pointer"
            name={`${collapse ? "arrow down" : "arrow up"}`}
          />
        </div>
      </div>
      <div className="mt-4" id={`nomina-row-to-show${element?.userId}`}>
        <div className="d-flex w-100 justify-content-between mb-2">
          <span className="text-center text-uppercase fs-12 fw-bold w-10"></span>
          <span className="text-center text-uppercase fs-12 fw-bold w-100">
            Usuario
          </span>
          <span className="text-center text-uppercase fs-12 fw-bold w-80">
            Rut
          </span>
          <span className="text-center text-uppercase fs-12 fw-bold w-100">
            Proveedor
          </span>
          <span className="text-center text-uppercase fs-12 fw-bold w-100">
            tipo de documento
          </span>
          <span className="text-center text-uppercase fs-12 fw-bold w-40">
            folio
          </span>
          <span className="text-uppercase fs-12 fw-bold w-100">
            monto seleccionado
          </span>
        </div>
        {!collapse &&
          element?.selected?.map((dt, index) => {
            return (
              <div
                key={`doc-${index}`}
                className="d-flex w-100 justify-content-between mb-3"
              >
                <span className="text-center text-truncate text-uppercase fs-12 w-10">
                  <input
                    type="checkbox"
                    checked={selectedDocsToNomina?.some(
                      (s) => s?.selectionId === dt?.selectionId
                    )}
                    onClick={(e) => addDocToNomina(dt, e.target.checked)}
                    id={`${element?.selectionId}-select-one-dte-${index}`}
                  />
                </span>
                <span className="text-center text-truncate fs-12 w-100">
                  {dt?.userEmail || element?.userEmail || 'Desconocido'}
                </span>
                <span className="text-center text-truncate text-uppercase fs-12 w-80">
                  {formatRut(dt?.issuerId)}
                </span>
                <span className="text-center text-truncate text-uppercase fs-12 w-100">
                  {dt?.issuerName}
                </span>
                <span className="text-center text-truncate text-uppercase fs-12 w-100">
                  {dt?.documentId === "0"
                    ? dt?.typeLabel
                    : documentsDic[dt?.documentCode]?.fullName ||
                      documentsDic[dt?.documentCode]?.label}
                </span>
                <span className="text-center text-truncate text-uppercase fs-12 w-40">
                  {dt?.documentId}
                </span>
                <span className="text-truncate text-uppercase fs-12 w-100">
                  {toMoney(dt?.amountSelected)}
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
}
